"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1534],{

/***/ 21534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ timeline_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs.js + 12 modules
var vertical_tabs = __webpack_require__(54837);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-tabs/timeline-tabs-component.scss.js

var StyledTimelineTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e8b7j1e0"
})("display:flex;align-items:center;justify-content:center;.vertical-tabs{.desktop-wrapper{.vertical-tabs-desktop-component{.vertical-tabs-wrapper{.vertical-tabs{.tabs{.tabs-wrapper{.vertical-tab{.vertical-tab-timeline{height:100%;margin-right:10px;border:3px solid;}}}}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-tabs/default-props.js
var default_props = __webpack_require__(66442);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-tabs/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var timeline_tabs_default_props = (_object_spread_props(_object_spread({}, default_props/* default */.Z), {
    backgroundColor: "light-blue-video-background",
    paddingTop: 0,
    paddingBottom: 0,
    titleSize: sizes.LG,
    tabsPosition: images_grid_service/* positionTypes.TOP_LEFT */.b.TOP_LEFT,
    minHeight: 500,
    addTimeline: true,
    addTabIndicator: false,
    fullBackground: true,
    lineColor: colors/* default */.Z[color_consts.WHITE_COLOR_NAME]
}));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-tabs/timeline-tabs-component.js
function timeline_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timeline_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timeline_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timeline_tabs_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function timeline_tabs_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        timeline_tabs_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var TimelineTabsComponent = function(props) {
    var fullBackground = props.fullBackground, theme = props.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimelineTabsComponent, {
        className: "timeline-tabs-component",
        style: {
            background: fullBackground && colors/* default */.Z[theme]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vertical_tabs/* default */.Z, timeline_tabs_component_object_spread_props(timeline_tabs_component_object_spread({}, props), {
            isDarkTheme: (0,segments_service/* isDarkTheme */.$o)(theme)
        }))
    });
};
TimelineTabsComponent.defaultProps = timeline_tabs_default_props;
/* harmony default export */ var timeline_tabs_component = (TimelineTabsComponent);


/***/ })

}]);